import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import ProfileEditContent from '../../../components/Pages/Profile/Edit';
import CategoriesProvider from '../../../components/Pages/Home/HowMuchToTip/CategoryProvider';

const { displayName } = config;

export default function ProfileEdit(): React.ReactElement {
  document.title = `${displayName}: Profile edit`;

  return (
    <Layout>
      <CategoriesProvider>
        <ProfileEditContent />
      </CategoriesProvider>
    </Layout>
  );
}
